import { INavigationNode } from '~/lib/data-contract';

export function lookupNodeByUrl(
    url: string | undefined,
    haystack: INavigationNode[] = []
): INavigationNode | undefined {
    if (!url) return undefined;

    for (let i = 0; i < haystack.length; i++) {
        const node = haystack[i];
        const { children = [], link } = node;

        // Check if current node is parent
        if (link?.url === url) {
            return node;
        } else if (children?.length) {
            // Check if parent in children
            const node = lookupNodeByUrl(url, children);

            if (node) {
                return node;
            }
        }
    }
}
